import { useMemo } from 'react'

import EditIcon from '@mui/icons-material/Edit'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import type {
  GridColDef,
  GridRenderCellParams,
  GridValueGetterParams,
} from '@mui/x-data-grid'
import { useQuery } from '@tanstack/react-query'
import Table from 'components/Table'
import { QUERY_KEYS } from 'constants/keys'
import { ROUTES } from 'constants/routes'
import { useNavigate } from 'react-router-dom'
import { ApiService } from 'services/api'

export default function PermissionsAssociated() {
  const navigate = useNavigate()

  const { data } = useQuery<PermissionAssociatedApiResponse[]>(
    QUERY_KEYS.PERMISSIONS_ASSOCIATED.LIST,
    () => ApiService.PermissionsAssociated.getAll(),
  )

  const columns = useMemo<GridColDef[]>(
    () => [
      {
        field: 'permissions',
        headerName: 'Name',
        flex: 1,
        valueGetter: (params: GridValueGetterParams<Permission>) => {
          return params.row.permission.name
        },
      },
      {
        field: 'actions',
        headerName: 'Ações',
        width: 80,
        sortable: false,
        renderCell: (params: GridRenderCellParams<Permission>) => {
          return (
            <EditIcon
              onClick={() => {
                navigate(ROUTES.PERMISSIONS_ASSOCIATED.EDIT(params.row.id))
              }}
            />
          )
        },
      },
    ],
    [navigate],
  )

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      <Container maxWidth={false}>
        <Box>
          <Box
            sx={{
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
            }}
          >
            <Typography sx={{ m: 1 }} variant="h4">
              Permissões
            </Typography>

            <Box sx={{ m: 1 }}>
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  navigate(ROUTES.PERMISSIONS_ASSOCIATED.CREATE)
                }}
              >
                Adicionar
              </Button>
            </Box>
          </Box>
        </Box>

        <Card sx={{ mt: 3 }}>
          <CardContent>
            <Table rows={data} columns={columns} />
          </CardContent>
        </Card>
      </Container>
    </Box>
  )
}
